import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  updateDoc,
  query,
  where,
  limit,
  startAfter,
  orderBy
} from 'firebase/firestore';
import { db } from '../../firebase';

const positionsCollection = collection(db, 'v_positions');

export const getPositions = async ({ action, batchLimit, start, search }) => {
  try {
    let q;
    if (action === 'load') {
      q = query(positionsCollection, orderBy('created_at'), limit(batchLimit));
    } else if (action === 'more') {
      q = query(
        positionsCollection,
        orderBy('created_at'),
        startAfter(start),
        limit(batchLimit)
      );
    } else if (action === 'search') {
      q = query(
        positionsCollection,
        where('title', '>=', search),
        where('title', '<=', search + '\uf8ff')
      );
    }

    const querySnapshot = await getDocs(q);
    const positions = querySnapshot.docs
      .map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    const last = querySnapshot.docs[querySnapshot.docs.length - 1];

    return { positions, last };
  } catch (error) {
    return error;
  }
};

export const createPosition = async data => {
  try {
    const res = await addDoc(positionsCollection, {
      title: data.title,
      election_id: data.election_id,
      vote_count: data.vote_count,
      client_types: data.client_types,
      sort_order: data.sort_order || 0,
      created_at: new Date().getTime(),
      updated_at: new Date().getTime(),
      status: data.status
    });

    return res;
  } catch (error) {
    return error;
  }
};

export const updatePosition = async data => {
  try {
    const res = await updateDoc(doc(db, 'v_positions', data.id), {
      title: data.title,
      election_id: data.election_id,
      vote_count: data.vote_count,
      client_types: data.client_types,
      sort_order: data.sort_order || 0,
      updated_at: new Date().getTime(),
      status: data.status
    });

    return res;
  } catch (error) {
    return error;
  }
};

export const deletePosition = async id => {
  try {
    const res = await deleteDoc(doc(db, 'v_positions', id));

    return res;
  } catch (error) {
    return error;
  }
};
